import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import Alert from './UI/Alert';
import CurrentSkillModal from './CurrentSkillModal';
import SkillBox from './SkillBox';
import Technology from '../types/Technology';
import Title from './UI/Title';
import technologies from '../assets/data/technologies';
import { renderSpanNoMobile } from '../services/renderValues';

/**
 * ## Display a list of technology that i know
 * You can click on an item to open a modale.
 * Opening a modale updates the url in the browser.
 */
function Skills() {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const [currentSkill, setCurrentSkill] = useState<Technology | undefined>();
  const [, setDesc] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal(tech: Technology) {
    setIsOpen(true);
    navigate(`#${tech?.name}`, { replace: true });
  }

  function updateCurrentSkillAndOpenModal(tech: Technology | undefined) {
    if (tech) {
      if (tech?.description) {
        fetch(tech.description)
          .then((response) => response.text())
          .then((text) => setDesc(text));
      } else {
        setDesc('');
      }
      setCurrentSkill(tech);
      openModal(tech);
    }
  }
  useEffect(() => {
    if (hash.length > 0) {
      const tech = technologies.find((t) => t.name === hash.substring(1));
      updateCurrentSkillAndOpenModal(tech);
    }
  }, []);

  function selectSkill(id: number) {
    updateCurrentSkillAndOpenModal(technologies.find((t) => t.id === id));
  }

  function closeModal() {
    setIsOpen(false);
    navigate('#skills', { replace: true });
  }
  return (
    <div className="row">
      <div className="col-12">
        <Title
          level={2}
          custom
          css="text-uppercase pb-4 pb-sm-5 mb-3 mb-sm-0 text-left text-sm-center ft-wt-600"
        >
          <FormattedMessage id="about.skills" />
        </Title>
      </div>

      <div className="col-12">
        <Alert>
          <FormattedMessage
            id="about.skills-information"
            values={
              {
                span: renderSpanNoMobile,
              } as Record<string, any>
            }
          />
          .
        </Alert>
      </div>

      <section className="row">
        {technologies.map((skill) => (
          <div className="col-lg-2 col-md-4 col-6" key={skill.name}>
            <SkillBox skill={skill} onClick={(id: number) => selectSkill(id)} />
          </div>
        ))}
      </section>

      {currentSkill && (
        <CurrentSkillModal
          closeModal={() => closeModal()}
          currentSkill={currentSkill}
          modalIsOpen={modalIsOpen}
        />
      )}
    </div>
  );
}

export default Skills;
